import React from 'react'
import { useAppState } from '@laststance/use-app-state'
import Contract from "./Contract.json";

const contractAddress = '0x888782EEb6A93f81fe3C94Ef636F42Cce3476068'

export default function useContract() {
    const [appState, setAppState] = useAppState()

    React.useEffect(async () => {
        console.log(appState.address, appState.balance)
        
        let user, sf, contract
        setAppState({isLoading: true})
        try {
            if (appState.web3) {
                contract = new appState.web3.eth.Contract(Contract.abi, contractAddress);

                // const result = await contract.methods.totalSupply().call();
                // console.log(result);

                const SuperfluidSDK = require("@superfluid-finance/js-sdk");

                sf = new SuperfluidSDK.Framework({
                    web3: appState.web3,
                });
                await sf.initialize()

                user = sf.user({
                    address: appState.address,
                    token: '0xF2d68898557cCb2Cf4C10c3Ef2B034b2a69DAD00'
                });
            }
        } finally {
            setAppState({user: user, sf: sf, contract: contract, isLoading: false})
        }
    }, [appState.web3])
}